import {_} from 'lodash';
import * as ko from "knockout";
import {nsUserSyncfields} from "./nsUserSyncfields";
import {IObjectData, ISyncField} from "../../../index";
import {TSyncfield_User} from "../../../constants/Syncfields";
import {getRawSyncFieldValue} from "../../../util/misc";
import {nsSyncFields} from "../../../req/nsSyncFields";
import ICard = nsUserSyncfields.ICard;
import positionsHtml from './positions.html?raw';

export const template = positionsHtml;

interface IParams {
    card: ICard
    object: IObjectData
}

export class viewModel {
    private readonly card: nsUserSyncfields.ICard;
    private readonly object: IObjectData
    private readonly index: KnockoutObservable<number> = ko.observable(0)

    constructor(params: IParams) {
        this.card = params.card
        this.object = params.object
    }

    private getPositions(): IObjectData[] {
        const syncfieldToCount = this.getSyncfieldToCount();
        if (!syncfieldToCount) {
            return [];
        }
        const positionCount = nsSyncFields.getArrayByString(getRawSyncFieldValue(syncfieldToCount, this.object.syncfields) ?? '')?.length ?? 0
        const ret: IObjectData[] = []
        for (let i = 0; i < positionCount; i++) {
            const obj = _.cloneDeep(this.object)
            obj.syncfields
                .filter((s: ISyncField) => s.value?.endsWith('|'))
                .forEach((syncfield: ISyncField) => {
                    const values = nsSyncFields.getArrayByString(syncfield.value)
                    syncfield.value = values?.[i] ?? ''
                })
            ret.push(obj)
        }
        switch (this.card.datasourcetype) {
            case "hr":
                return _.sortBy(ret, (o: IObjectData) => !this.isPrimaryPosition(o))
            case "edu":
                return ret
            default:
                return ret
        }
    }

    private getSyncfieldToCount(): TSyncfield_User | undefined {
        switch (this.card.datasourcetype) {
            case "hr":
                return 'APrimaryPosition';
            case "edu":
                return 'AeduPositionName';
            default:
                return undefined;
        }
    }

    private isPrimaryPosition(object: IObjectData): boolean {
        const syncfieldName = this.getPrimaryPositionSyncfieldName();
        if (!syncfieldName) {
            return false;
        }
        return getRawSyncFieldValue(syncfieldName, object.syncfields)?.toLowerCase() == 'true'
    }

    private getPrimaryPositionSyncfieldName(): TSyncfield_User | undefined {
        switch (this.card.datasourcetype) {
            case "hr":
            case "edu":
                return 'APrimaryPosition';
            default:
                return undefined;
        }
    }

    private hasValue(syncfieldname: TSyncfield_User, object: IObjectData): boolean {
        return !!this.getValue(syncfieldname, object)
    }

    private getValue(syncfieldname: TSyncfield_User, object: IObjectData): string {
        return getRawSyncFieldValue(syncfieldname, object.syncfields) ?? ''
    }


}
